import axios from "axios";
import BackEndpoints from "@/router/endpoints/BackEndpoints";
import ToastService from "@/services/ToastService";
import BrandService from "@/services/BrandService";

export default {
  async syncKits(kitUrl) {
    let brand = await BrandService.getDefaultBrand();
    const resp = await axios.get(BackEndpoints.syncKits(brand.id), {
      params: {
        kitUrl: kitUrl,
      },
    });
    if (resp.status === 200 && resp?.data?.warnings?.length) {
      ToastService.warning("Warnings", resp.data.warnings);
    }
  },
  async saveKitUrl(kitUrl) {
    let brand = await BrandService.getDefaultBrand();
    brand.kitUrl = kitUrl;
    await axios.put(BackEndpoints.brand(brand.id), brand);
  },

  async getKitUrl() {
    try{
      let brand = await BrandService.getDefaultBrand();
      return brand.kitUrl;
    }
    catch (e) {
      console.log("Error fetching kit URL:", e.message);
    }
  },
};
